import { getConfigValue } from '@jutro/config';
export const fetchUserInfo = async accessToken => {
  const userInfoEndPoint = "".concat(getConfigValue('JUTRO_AUTH_ISSUER', ''), "/v1/userinfo");
  const userInfo = await fetch(userInfoEndPoint, {
    headers: {
      Authorization: "Bearer ".concat(accessToken)
    },
    method: 'GET'
  });
  return userInfo.json();
};